/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Sponsor entry with logo and optional link
 * @export
 * @interface SurfaceSponsorItem
 */
export interface SurfaceSponsorItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceSponsorItem
     */
    _id?: string;
    /**
     * Resolved from logoImageId on read.
     * @type {string}
     * @memberof SurfaceSponsorItem
     */
    logoImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSponsorItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSponsorItem
     */
    tier?: SurfaceSponsorItemTierEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSponsorItem
     */
    logoImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSponsorItem
     */
    url?: string;
}


/**
 * @export
 */
export const SurfaceSponsorItemTierEnum = {
    PRESENTING: 'PRESENTING',
    SUPPORTING: 'SUPPORTING',
    COMMUNITY: 'COMMUNITY'
} as const;
export type SurfaceSponsorItemTierEnum = typeof SurfaceSponsorItemTierEnum[keyof typeof SurfaceSponsorItemTierEnum];


/**
 * Check if a given object implements the SurfaceSponsorItem interface.
 */
export function instanceOfSurfaceSponsorItem(value: object): value is SurfaceSponsorItem {
    return true;
}

export function SurfaceSponsorItemFromJSON(json: any): SurfaceSponsorItem {
    return SurfaceSponsorItemFromJSONTyped(json, false);
}

export function SurfaceSponsorItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceSponsorItem {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'logoImageUrl': json['logoImageUrl'] == null ? undefined : json['logoImageUrl'],
        'name': json['name'] == null ? undefined : json['name'],
        'tier': json['tier'] == null ? undefined : json['tier'],
        'logoImageId': json['logoImageId'] == null ? undefined : json['logoImageId'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function SurfaceSponsorItemToJSON(json: any): SurfaceSponsorItem {
    return SurfaceSponsorItemToJSONTyped(json, false);
}

export function SurfaceSponsorItemToJSONTyped(value?: SurfaceSponsorItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'logoImageUrl': value['logoImageUrl'],
        'name': value['name'],
        'tier': value['tier'],
        'logoImageId': value['logoImageId'],
        'url': value['url'],
    };
}

